import React from 'react';
import CellChipComponent from '../EForm/FormField/cell-chip';
import CellDropdownComponent from '../EForm/FormField/cell-dropdown';
import CellFileUploadComponent from '../EForm/FormField/cell-file-upload';
import CellBooleanComponent from '../EForm/FormField/cell-boolean';
import CellBooleanRadioComponent from "../EForm/FormField/cell-boolean-radio";
import CellMultiDropdownComponent from "../EForm/FormField/cell-multi-select";
import CellStringComponent from '../EForm/FormField/cell-string';
import CellNumberComponent from '../EForm/FormField/cell-number';
import PropTypes from 'prop-types';
import CellModelTermsComponent from "../EForm/FormField/cell-model-terms";
import CellDynamicSelectComponent from "../EForm/FormField/cell-dynamic-select";
import CellTextareaComponent from "../EForm/FormField/cell-textarea";
import { useFeature } from "@/hooks/use-feature/index";
import { featureConstant } from "@/constants/configuration/feature";

// Bypass component for dynamic-select and textarea fields
const BypassComponent = ({ label, value }) => {
    return (
        <div className="form-field-bypass" style={{ 
            padding: '8px', 
            backgroundColor: '#f5f5f5', 
            borderRadius: '4px',
            border: '1px dashed #ccc',
            color: '#666'
        }}>
            {label && <strong>{label}: </strong>}
            <span>Bypassed field - {value || 'No value'}</span>
        </div>
    );
};

const FormFieldDictionary = {
    "string": CellStringComponent,
    "dropdown": CellDropdownComponent,
    "multi-select": CellMultiDropdownComponent,
    "file-upload": CellFileUploadComponent,
    "number": CellNumberComponent,
    "integer": CellNumberComponent,
    "boolean": CellBooleanComponent,
    "radio": CellBooleanRadioComponent,
    "array": CellChipComponent,
    "dynamic-dropdown": CellModelTermsComponent,
    "dynamic-select": CellDynamicSelectComponent,
    "textarea": CellTextareaComponent
};

const FormField = (props) => {
    const { type, ...otherProps } = props;
    const isSubmittalsEnabled = useFeature(featureConstant.SUBMITTALS);

    const Component = ((type === "dynamic-select" || type === "textarea") && !isSubmittalsEnabled)
        ? BypassComponent
        : FormFieldDictionary[type];

    if (!Component) {
        throw new Error(`Unsupported type: ${type}`);
    }

    return <Component {...otherProps} />;
};

FormField.propTypes = {
    type: PropTypes.oneOf(Object.keys(FormFieldDictionary)),
};

export default FormField;
